// extracted by mini-css-extract-plugin
export var ofset = "style-module--ofset--2c436";
export var sectionBannerStyles = "style-module--sectionBannerStyles--9af5a";
export var sectionTitleStyles = "style-module--sectionTitleStyles--7c09d";
export var sectionleftStrike = "style-module--sectionleftStrike--f9508";